'use client'

import FullProdSlider from '@/components/catalog/FullProdSlider'
import Header from '@/components/header/Header'
import React, { useEffect } from 'react'
// import logoMain from '@/assets/img/logo-main.svg'
import logoMain from '@/assets/img/dark-vers.svg'
import MainAbout from '@/components/main/MainAbout'
import bg from '@/assets/img/products/production-bg.png'
import FeaturesBlock from '@/components/FeaturesBlock'
import MainSlider from '@/components/main/MainSlider'
import { categoriesSliderList } from '@/assets/data/useful-materials'
import materialsSettings from '@/assets/data/main-materials-slider.json'
import Footer from '@/components/Footer/Footer'
import Link from 'next/link'
import { useGetMaterialsCategoriesQuery } from '@/redux/services/materialsApi'
import CatalogCategoriesSlider from '@/components/catalog/CatalogCategoriesSlider'
import { useDispatch } from 'react-redux'
import { setResetCatalogFilters, setResetMaterialsFilters, setResetNewsFilters } from '@/redux/features/filterSlice'
import MainSceneWithWrapper from '@/components/MainSceneWithWrapper/MainSceneWithWrapper'
import CardSlider from '@/components/CardSlider'
import { useTranslation } from 'react-i18next'

const LabsModule = () => {
    const dispatch = useDispatch()
    const { t } = useTranslation()

    useEffect(() => {
        dispatch(setResetNewsFilters())
        dispatch(setResetMaterialsFilters())
        dispatch(setResetCatalogFilters())
    }, [])

    const { data: materialsCategoriesData } = useGetMaterialsCategoriesQuery()

    const headSliderList = [t('Laboratory'), 'NIRS']

const slideItem = {
    // page: 'labs',
    items: [
        {
            title: t("Laboratory"),
            text: [
                t('laboratory_content_1'),
                t('laboratory_content_2')
            ],
            cardClass: 'product__slide'
        },
        {
            title: 'NIRS',
            text: [t('nirs_content')],
            cardClass: 'product__slide'
        }
    ],
    btn: {
        content: t('user_account'),
        link: 'https://lab.megamix.ru/login/',
        icon: 'user',
        isBlank: true
    }
}

const nirs = {
    tag: t('card_tag'),
    title: t('card_header'),
    text: [
        t('card_content_1'),
        t('card_content_2'),
        t('card_content_3')
    ],
    // cardLink: 'Исследование рынка 2022 года',
    btn: {
        content: t('user_account'),
        link: 'https://lab.megamix.ru/login/',
        icon: 'user'
    },
    btn2: {
        content: t('learn_more'),
        link: `/useful-materials/NIRS-analiz-%E2%80%93-kak-balansirovat-raciony-bystro-i-tochno`,
        icon: 'flask'
    }
}

const featuresList = [
    {
        id: '1',
        title: t('card_1_header'),
        image_url: "/assets/img/features/frame-1.png",
        bottomLine: "NIRS",
        description: t('card_1_content'),
    },
    {
        id: '2',
        title: t('card_2_header'),
        image_url: "/assets/img/features/frame-2.png",
        bottomLine: "NIRS",
        description: t('card_2_content')
    },
    {
        id: '3',
        title: t('card_3_header'),
        image_url: "/assets/img/features/frame-3.png",
        bottomLine: "NIRS",
        description: t('card_3_content')
    },
    {
        id: '4',
        title: t('card_4_header'),
        image_url: "/assets/img/features/frame-4.png",
        bottomLine: "NIRS",
        description: t('card_4_content')
    },
    {
        id: '5',
        title: t('card_5_header'),
        image_url: "/assets/img/features/frame-5.png",
        bottomLine: "NIRS",
        description: t('card_5_content')
    },
    {
        id: '6',
        title: t('card_6_header'),
        image_url: "/assets/img/features/frame-6.png",
        bottomLine: "NIRS",
        description: t('card_6_content')
    },
    {
        id: '7',
        title: t('card_7_header'),
        image_url: "/assets/img/features/frame-7.png",
        bottomLine: "NIRS",
        description: t('card_7_content')
    }
]

    return (
        <main className='main labs'>
            {/* <div className="home__light-blue"></div>
            <div className="home__purple-1"></div>
            <div className="home__purple-2"></div>
            <div className="home__violet"></div> */}
            <Header
                burgerBg='linear-gradient(180deg, #3156A8 21.87%, #2D3079 108.55%)' />
            <MainSceneWithWrapper bottomBlur={true} />
            <div className="container">
                <div className="media__top labs__top">
                    <Link href={'/#map-cards'} style={{ position: "relative", zIndex: 5 }}>
                        <button className='buttons buttons__maps'>
                            <svg
                                width='19'
                                height='19'
                                viewBox='0 0 19 19'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                            >
                                <g opacity='0.6'>
                                    <path
                                        d='M1 3.34483L5.95833 1V15.6552L1 18V3.34483Z'
                                        stroke='#CBD9F9'
                                        strokeWidth='1.6'
                                        strokeLinecap='round'
                                        strokeLinejoin='round'
                                    />
                                    <path
                                        d='M12.3334 3.34483L18 1V15.6552L12.3334 18V3.34483Z'
                                        stroke='#CBD9F9'
                                        strokeWidth='1.6'
                                        strokeLinecap='round'
                                        strokeLinejoin='round'
                                    />
                                    <path
                                        d='M12.3334 3.34483L5.95837 1V15.6552L12.3334 18V3.34483Z'
                                        stroke='#CBD9F9'
                                        strokeWidth='1.6'
                                        strokeLinecap='round'
                                        strokeLinejoin='round'
                                    />
                                </g>
                            </svg>
                            {t('BackToMap')}
                        </button>
                    </Link>
                    {/* <FullProdSlider
                        zIndex={5}
                        list={slideItem}
                        page='labs'
                        link='https://lab.megamix.ru/login/'
                        headSlider={headSliderList} /> */}
                    <CardSlider list={slideItem} headSlider={headSliderList} />
                </div>
                <MainAbout item={nirs} bg={bg} />
                <h2 className='main__section-title'>{t('benefits')}</h2>
                <FeaturesBlock list={featuresList} classItem='labs__features-card' />
                <CatalogCategoriesSlider type='labs' list={featuresList} />
                <h2 className='main__section-title'>{t('usefulMaterialsTitle')}</h2>
            </div>
            {materialsCategoriesData && <MainSlider
                settings={materialsSettings}
                type={'useful-materials'}
                list={materialsCategoriesData}
            />}
            {/* <div className="container"> */}
            <Footer />
            {/* </div> */}
        </main>
    )
}

export default LabsModule
